module.exports = __webpack_public_path__ + "static/media/introduce_more0.333cd815.png";